import { Form, Select, Space } from 'antd';
import { Placement } from 'rc-select/lib/BaseSelect';
import moment from 'moment';

const genHours: (startFrom?: number, stopAt?: number) => string[] = (
  startFrom = 0,
  stopAt = 23,
) => {
  const items: string[] = [];
  for (let index = startFrom; index <= stopAt; index++) {
    const hour = index.toString();
    items.push(hour.length === 1 ? '0' + hour : hour);
  }
  return items;
};
const genMinutes: (
  minuteStep?: number,
  minuteStartFrom?: number,
) => string[] = (minuteStep, minuteStartFrom = 0) => {
  const items: string[] = [];
  for (let index = minuteStartFrom; index < 60; index++) {
    if (minuteStep) {
      if (index % minuteStep === 0) {
        const item = index.toString();
        items.push(item.length === 1 ? '0' + item : item);
      }
    } else {
      const item = index.toString();
      items.push(item.length === 1 ? '0' + item : item);
    }
  }
  return items;
};
const secondOptions: string[] = (() => {
  const items: string[] = [];
  for (let index = 0; index < 24; index++) {
    const hour = index.toString();
    items.push(hour.length === 1 ? '0' + hour : hour);
  }
  return items;
})();

type TimePickerProps = {
  format?: string;
  hourStartFrom?: number;
  hourStopAt?: number;
  minuteStartFrom?: number;
  minuteStep?: number;

  value?: string;
  placement?: Placement;
  onChange?: (value: string) => void;
};
export const TimePicker = ({
  format,
  hourStartFrom,
  hourStopAt,
  minuteStartFrom,
  minuteStep,

  value,
  placement,
  onChange,
}: TimePickerProps) => {
  const arrFormat = format ? format.split(':') : ['HH', 'mm', 'ss'];

  const [hour = '00', minute = '00', second = '00'] = value?.split(':') || [
    undefined,
    undefined,
    undefined,
  ];

  return (
    <>
      <Space size={12}>
        {arrFormat.map((x, i) => {
          let value: string | undefined = undefined;
          let placeholder = '';
          let disabled = false;
          let options: string[] = [];

          if (x === 'HH') {
            options = genHours(hourStartFrom, hourStopAt);
            value = hour;
            placeholder = 'HH';
          } else if (x === 'mm') {
            value = minute;
            placeholder = 'mm';
            if (hour === '24') {
              disabled = true;
              options = ['00'];
            } else {
              options = genMinutes(minuteStep, minuteStartFrom);
            }
          } else {
            value = second;
            placeholder = 'ss';
            options = secondOptions;
          }

          return (
            <Form.Item key={i} noStyle>
              <Select
                value={value}
                placement={placement}
                placeholder={placeholder}
                style={{ minWidth: 130 }}
                onChange={(value) => {
                  onChange &&
                    onChange(
                      // if selecting hour
                      i === 0 && value === '24'
                        ? '24:00:00'
                        : moment(
                            i === 0
                              ? [value, minute, second].join(':')
                              : [hour, value, second].join(':'),
                            'HH:mm:ss',
                          ).format(format),
                    );
                }}
                disabled={disabled}
              >
                {options.map((x) => {
                  return (
                    <Select.Option key={x} value={x}>
                      {x}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
          );
        })}
      </Space>
    </>
  );
};
